module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('div', {
    staticClass: "fade-transition ng-scope",
    attrs: {
      "ng-view": ""
    }
  }, [_c('section', {
    staticClass: "content-header ng-scope"
  }, [_c('h1', [_vm._v("Preferências")]), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": [{
        text: 'Inicial',
        href: '/'
      }, {
        text: 'Preferências',
        href: '#'
      }]
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "content ng-scope"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-body box-profile"
  }, [_c('div', {
    attrs: {
      "id": "preview"
    }
  }, [_c('img', {
    staticClass: "profile-user-img img-responsive img-circle",
    attrs: {
      "alt": "User profile picture",
      "src": _vm.usuarioLogado.bl_foto || '/static/img/nouser.png'
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    staticClass: "text-center",
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_c('input', {
    staticClass: "hidden",
    attrs: {
      "id": "files",
      "type": "file",
      "Alterar": "",
      "Foto": ""
    },
    on: {
      "change": function($event) {
        return _vm.onFileChange($event)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "btn btn-default btn-xs btn-flat",
    attrs: {
      "for": "files"
    }
  }, [_vm._v("Alterar")]), _vm._v(" "), _c('input', {
    staticStyle: {
      "opacity": "0",
      "height": "1px"
    },
    attrs: {
      "type": "file",
      "id": "photo",
      "accept": ".png,.jpg"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "profile-username text-center"
  }, [_vm._v(_vm._s(_vm.usuarioLogado.ds_nome_usuario))]), _vm._v(" "), _c('ul', {
    staticClass: "list-group list-group-unbordered"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("E-mail")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.usuarioLogado.ds_email))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "nav-tabs-custom"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    attrs: {
      "uib-collapse": "authBox.isCollapsed"
    }
  }, [_c('form', {
    attrs: {
      "name": "frmChangePassword"
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.usuarioLogado.ds_tipo_usuario !== 'FUNDACAO') ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Alterar Senha ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group has-feedback",
    class: {
      'has-error': _vm.errors.first('senhaAtual')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password.senhaAtual),
      expression: "password.senhaAtual"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "senhaAtual",
      "name": "senhaAtual",
      "type": "password",
      "placeholder": "Informe a senha atual"
    },
    domProps: {
      "value": (_vm.password.senhaAtual)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.password, "senhaAtual", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon glyphicon-lock form-control-feedback"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.first('senhaAtual')),
      expression: "errors.first('senhaAtual')"
    }],
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('Campo requerido')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group has-feedback",
    class: {
      'has-error': _vm.errors.first('novaSenha')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password.novaSenha),
      expression: "password.novaSenha"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "novaSenha",
      "name": "novaSenha",
      "type": "password",
      "placeholder": "Informe a nova senha"
    },
    domProps: {
      "value": (_vm.password.novaSenha)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.password, "novaSenha", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon glyphicon-lock form-control-feedback"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.first('novaSenha')),
      expression: "errors.first('novaSenha')"
    }],
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('Campo requerido')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group has-feedback",
    class: {
      'has-error': _vm.errors.first('confirmaSenha')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password.confirmaSenha),
      expression: "password.confirmaSenha"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "confirmaSenha",
      "name": "confirmaSenha",
      "type": "password",
      "placeholder": "Confirme a nova senha"
    },
    domProps: {
      "value": (_vm.password.confirmaSenha)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.password, "confirmaSenha", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon glyphicon-lock form-control-feedback"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.first('confirmaSenha')),
      expression: "errors.first('confirmaSenha')"
    }],
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('Campo requerido')))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isValidPassword()),
      expression: "!isValidPassword()"
    }],
    staticClass: "label label-danger"
  }, [_vm._v("As senhas devem ser iguais")])])]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.ds_tipo_usuario == 'FUNDACAO') ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Alterar Senha ")]), _vm._v(" "), _vm._m(1)]) : _vm._e()])]), _vm._v(" "), (_vm.usuarioLogado.ds_tipo_usuario !== 'FUNDACAO') ? _c('div', {
    staticClass: "box-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-flat",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onChangePassword(_vm.password)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Alterar Senha\n                  ")])]) : _vm._e()])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v(" Autenticação ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "callout callout-warning",
    staticStyle: {
      "margin-bottom": "0!important"
    }
  }, [_c('h4', [_vm._v("Atenção")]), _vm._v("\n                        Contacte o administrador da rede para efetuar a alteração de sua senha.\n                      ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-52ae035e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Preferencias.vue
// module id = 1960
// module chunks = 1